<template>
    <div>
        <div
            id="content"
            class="content animated slideInRight delay-1s"
        >
            <div class="row">
                <div class="col-md-12">
                    <div class="card">
                        <div class="card-header">
                            <div class="card-title">
                                Cadastrar Diagrama de Rede
                                <span
                                    class="required_fields"
                                >
                                    <span class="required">*</span>
                                    Campos obrigatórios
                                </span
                                >
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="section-form">
                                <form id="form">
                                    <div class="row">
                                        <div class="col-md-6 mb-3">
                                            <label>
                                                <span class="required">*</span>
                                                Diagrama de Rede:
                                            </label>
                                            <input
                                                v-model="network_diagram.description"
                                                class="form-control"
                                            >
                                        </div>

                                        <div class="col-md-3 mb-3">
                                            <label>
                                                <span class="required">*</span>
                                                Código ERP:
                                            </label>
                                            <input
                                                v-model="network_diagram.erp_code"
                                                class="form-control"
                                            >
                                        </div>
                                    </div>

                                    <div class="block text-right">
                                        <router-link
                                            to="/network-diagrams"
                                            class="btn btn-back"
                                        >
                                            <i class="fa fa-arrow-left mr-2"></i>
                                            Voltar
                                        </router-link>

                                        <a
                                            class="btn btn-add"
                                            @click="save"
                                        >
                                            Salvar
                                            <i class="fa fa-save ml-2"></i>
                                        </a>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {getMessage} from "../../composables/message";

export default {
    data() {
        return {
            network_diagram: {
                description: "",
                erp_code: ''
            },

            errors: undefined,
        };
    },
    computed: {},
    methods: {
        save: function () {
            let url = this.$store.state.api + "network-diagrams";
            if (this.network_diagram.id) {
                url = this.$store.state.api + "network-diagrams/" + this.network_diagram.id;
                this.network_diagram._method = 'PUT';
            }
            const self = this;

            self.$http
                .post(url, self.network_diagram)
                .then((response) => {
                    self.$message("Sucesso", `Diagrama de Rede cadastrado com sucesso`, "success");
                    this.$router.push("/network-diagrams");
                })
                .catch((error) => {
                    const message = error.response.data.errors ? getMessage(error.response.data.errors) : error.response.data
                    self.$message(null, message, "error");
                });
        },

        getData(id) {
            const api = this.$store.state.api + "network-diagrams/" + id;
            const self = this;

            self.$http
                .get(api)
                .then((response) => {
                    self.network_diagram = response.data.data[0];
                })
                .catch((error) => {
                    console.log(error);
                });
        }
    },
    mounted: function () {
        const id = this.$route.params.id;
        if (id) {
            this.getData(id);
        }
    },
};
</script>



// WEBPACK FOOTER //
// src/components/NetworkDiagram/Add.vue